<template>
	<div class="box">
		<div style="background-color: #FFFFFF;" class="arrow-img"></div>
		<span class="title">请选择要迁入的账号</span>
		<span class="tips">
			将以下选中公众号的信息（书币，会员，阅读记录等）迁入到当前公众号
		</span>
		<div @click="chooseAccount(item,index)" v-for="(item,index) in account" :key="index" class="item-acccount"
			:class="selectAccount==index?'item-active':''">
			<div class="item-top">
				<span>公众号名称：{{item.officialName}}</span>
				<span>ID:{{item.transferId}}</span>
			</div>
			<div>
				<span>书币:{{item.currency}}</span>
				<span style="margin-left:20px;">会员:{{item.vipDay}}天</span>
			</div>
		</div>
		<div class="confirm-btn" @click="confirmAccount">
			<span>确认迁入</span>
		</div>
	</div>
</template>
<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		data() {
			return {
				selectAccount: 0,
				account: [],
				transferOpenId: 0
			}
		},
		mounted() {
			this.getSameAccountList();
		},
		methods: {
			chooseAccount(item, index) {
				this.selectAccount = index;
				this.transferOpenId = item.transferOpenId;
			},
			getSameAccountList() {
				this.$api.getSameAccountList().then(res => {
					if (res.status == 1) {
						this.account = res.data;
						if (res.data.length > 0) {
							this.transferOpenId = res.data[0].transferOpenId;
						}else{
							this.$router.push({
								path:'/pages/noAccount/index'
							})
						}
					}
				})
			},
			confirmAccount() {
				var params = {
					transferOpenId: this.transferOpenId
				}
				   MessageBox.confirm("确定要进行数据迁移吗？").then((action) => {
        console.log(action);
        if (action == "confirm") {
         this.$api.startTransferUser(params).then(res => {
									if (res.status == 1) {
										this.$router.push({
											path:'/pages/moveSuccess/index'
										})
									} else {
										Toast({
											meesage: res.message
										})
									}
								})
        }
      });
			}
		}
	}
</script>
<style scoped>
	.arrow-img {
		width: 30px;
		height: 44px;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
	}

	.item-acccount {
		border: 1px solid #D7D7D7;
		border-radius: 8px;
		padding: 17px;
		margin-bottom: 16px;
	}

	.item-active {
		border: 2px solid #DE3B34;
		padding: 16px;
	}

	.item-top {
		margin-bottom: 12px;
	}

	.item-acccount>div:nth-child(2) {
		font-size: 14px;
		color: #888888;
	}

	.item-top>span:nth-child(1) {
		font-size: 16px;
		color: #333333;
		font-weight: bold;
		margin-right: 8px;
	}

	.item-top>span:nth-child(2) {
		font-size: 12px;
		color: #888888;
	}

	.box {
		padding: 16px;
	}

	.title {
		font-size: 18px;
		color: #333333;
		font-weight: bold;
		display: block;
		text-align: center;
		margin-bottom: 8px;
	}

	.tips {
		font-size:14px;
		color: #888888;
		line-height: 20px;
		display: block;
		margin-bottom: 20px;
	}

	.confirm-btn {
		width: 100%;
		height:44px;
		color: #ffffff;
		text-align: center;
		background-color: #DE3B34;
		font-size: 16px;
		line-height: 44px;
		position: fixed;
		width: 100%;
		left: 0px;
		bottom: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/view/chooseAccount/index.vue